import type { MaterialOrderRequestColumn } from '../../types/column-types'

export const requestNumberColumn: MaterialOrderRequestColumn = {
    title: 'Номер заявки',
    dataIndex: 'id',
    width: 50,
}
